export default function SafetyBadgeSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#1B4332] via-[#2D6A4F] to-[#1B4332] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-[#D4AF37] to-[#B8941F] rounded-full shadow-2xl mb-8">
            <i className="ri-shield-check-fill text-5xl text-[#1B4332] w-12 h-12 flex items-center justify-center"></i>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            安心・安全のお約束
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent mx-auto mb-6"></div>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お客様に安心してご利用いただくため、<br />
            買い取りかわせみは厳格なコンプライアンス基準を遵守しております
          </p>
        </div>

        {/* Trust Shield Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {/* Badge 1 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 border-2 border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 bg-[#D4AF37] rounded-2xl flex items-center justify-center shadow-xl">
                <i className="ri-door-closed-line text-3xl text-[#1B4332] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  アポなしの訪問・勧誘は一切いたしません
                </h3>
                <p className="text-lg text-white/80 leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  お客様のご予約に基づき、ご指定の日時にのみお伺いします。飛び込み営業や強引な勧誘は一切行いませんのでご安心ください。
                </p>
              </div>
            </div>
          </div>

          {/* Badge 2 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 border-2 border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 bg-[#D4AF37] rounded-2xl flex items-center justify-center shadow-xl">
                <i className="ri-checkbox-circle-line text-3xl text-[#1B4332] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  ご依頼いただいた品物のみを査定いたします。
                </h3>
                <p className="text-lg text-white/80 leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  お客様が指定されたお品物のみを一点一点丁寧に査定します。「他に売るものはないか」と無理に聞き出したり、家の中を物色したりすることは一切ございません。
                </p>
              </div>
            </div>
          </div>

          {/* Badge 3 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 border-2 border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 bg-[#D4AF37] rounded-2xl flex items-center justify-center shadow-xl">
                <i className="ri-refresh-line text-3xl text-[#1B4332] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  安心のクーリング・オフ制度に対応
                </h3>
                <p className="text-lg text-white/80 leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  特定商取引法に基づき、ご契約から8日以内であれば無条件でキャンセルが可能です。お客様の権利を最優先に考え、誠実に対応いたします。
                </p>
              </div>
            </div>
          </div>

          {/* Badge 4 - License */}
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 border-2 border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 bg-[#D4AF37] rounded-2xl flex items-center justify-center shadow-xl">
                <i className="ri-government-line text-3xl text-[#1B4332] w-8 h-8 flex items-center justify-center"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  神奈川県公安委員会 許可
                </h3>
                <p className="text-lg text-white/80 leading-relaxed mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  古物営業法に基づく正規の許可を取得しております。法令を遵守し、適切な手続きのもと営業しております。
                </p>
                <div className="inline-block bg-[#D4AF37] px-6 py-3 rounded-full">
                  <p className="text-base font-bold text-[#1B4332]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    許可番号：第451370014326号
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Trust Elements */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 border-2 border-[#D4AF37]/50">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <i className="ri-user-heart-line text-5xl text-[#D4AF37] mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                お客様第一主義
              </h4>
              <p className="text-base text-white/80" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                納得いただけるまで<br />丁寧にご説明いたします
              </p>
            </div>
            <div>
              <i className="ri-lock-password-line text-5xl text-[#D4AF37] mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                個人情報保護
              </h4>
              <p className="text-base text-white/80" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                お客様の情報は<br />厳重に管理いたします
              </p>
            </div>
            <div>
              <i className="ri-file-list-3-line text-5xl text-[#D4AF37] mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
              <h4 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                透明性のある取引
              </h4>
              <p className="text-base text-white/80" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                査定内容を明確に<br />書面でご提示いたします
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Message */}
        <div className="text-center mt-12">
          <p className="text-xl text-white/90 leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お客様に安心してご利用いただける環境づくりに、全力で取り組んでおります。<br />
            ご不明な点やご心配なことがございましたら、どうぞお気軽にお問い合わせください。
          </p>
        </div>
      </div>
    </section>
  );
}